<template>
    <Row>
        <Column class="text-left" :class="sizeClasses">
            <hr />
        </Column>
    </Row>
</template>

<script>
import sizeClassesMixin from "@/components/html/mixin/sizeClassesMixin";
import Column from "@/components/html/Column";
import Row from "@/components/html/Row";

export default {
    name: "HrRow",
    components: {Row, Column},
    mixins: [sizeClassesMixin]
}
</script>

<style scoped>

</style>